export const sliderData = {
	input_type: 'NUMBER',
	maxLabel: {},
	minLabel: {},
	scale: '5',
	stepValue: 1,
	userPrompt: '',
	validationMessage: '',
	zeroIndex: false,
	id: '',
};
